import strings from "common/strings";
import Radio from "backbone.radio";
import { useEffect } from "react";
import { captureBreadcrumb } from "extensions/sentry";
import { AuthRoute, useRouteMatch, useParams } from "extensions/react-router";

import { store } from "common/store";
import { ensureErrorCallback } from "common/components/error";
import { pazienHistory } from "common/components/pazienHistory";
import { Qualifiers } from "common/components/queryBuilder/qualifiers";

import { Dashboard3 } from "./dashboard3";

export function DashboardRouter() {
    const { url } = useRouteMatch();
    return <AuthRoute path={`${url}/dashboard/:filters?`} component={DashboardComponent} />;
}

const makeQualifiersInstance = (str = "") => new Qualifiers({
    value: str,
    whitelisted: Object.keys(Radio.channel("main").request("get:getters").allPivots())
});

function DashboardComponent() {
    const { filters } = useParams();

    useEffect(() => {
        const navigate = ({ qualifiers = makeQualifiersInstance(), refresh = true }, context) => {
            captureBreadcrumb({
                message: "Applying filters in the dashboard",
                category: "Dashboard",
                data: {
                    qualifiers: qualifiers.toJSON(),
                    refresh
                }
            });
            
            const q = qualifiers.toString(true);
            pazienHistory.navigateWithParams(`dashboard/${q}`, { trigger: true });
        };

        Radio.channel("dashboard").on("navigate", navigate);

        return () => Radio.channel("dashboard").off("navigate", navigate);
    }, []);

    useEffect(() => {
        async function main() {
            try {
                if (store.getState().permissions.user_permissions.feature_dashboard) {
                    const { dataTypes } = await import(
                        /* webpackChunkName: "dataAvailability" */
                        "common/actions/dataAvailability"
                    );
                    
                    // Flag to check if the url should be replaced because it's formatted wrong
                    let qualifiers;
                    try {
                        qualifiers = makeQualifiersInstance(filters);
                    } catch {
                        qualifiers = makeQualifiersInstance();
                        pazienHistory.navigateWithParams("dashboard/", { replace: true });
                    }
                    
                    Radio.channel("main").request("show:app:view", new Dashboard3({
                        qualifiers,
                        name: strings.page_dashboard,
                        dataAvailabilityType: [
                            dataTypes.SETTLEMENTS,
                            dataTypes.CHARGEBACKS,
                            dataTypes.FEES,
                            dataTypes.AUTHORIZATIONS
                        ]
                    }));
                } else {
                    const { Splash } = await import(
                        /* webpackChunkName: "splash" */
                        "merchant/features/splash/splash"
                    );
                    const splashView = new Splash({
                        sidebar_name: "dashboard",
                        name: "splash"
                    });
                    
                    Radio.channel("main").request("show:app:view", splashView);
                }
            } catch (error) {
                ensureErrorCallback(error);
            }
        }

        main();
    }, [filters]);

    return null;
}
